import { type InferResponseType, unwrap } from "@nexxt/api-client";
import { queryOptions } from "@tanstack/react-query";
import { api } from "../../api";

// Server state of the delivery tolerance bands (50-api/procurement.md §2.7, V-02): the global set and the one of each
// brand that has its own, all at once.

const bands = api.procurement["tolerance-bands"];

type ToleranceBands = InferResponseType<typeof bands.$get, 200>;
export type ToleranceBand = ToleranceBands["global"][number];

const keys = { all: ["tolerance-bands"] as const };

export const toleranceBandQueries = {
  ...keys,

  list: () =>
    queryOptions({
      queryKey: [...keys.all, "list"],
      queryFn: ({ signal }) => unwrap(bands.$get({}, { init: { signal } })),
    }),
};
